/* globals grecaptcha */

(function () {
    'use strict';

    function main() {
        var page = wo$('#contact');
        if (!page.length) return;
        var clientData = WhistleOut.readLookupData(page);

        var controller = {
            init: function () {
                controller.bind();
            },

            bind: function () {
                page.find('#name').focus();

                page.find('#form').submit(function (event) {
                    event.preventDefault();
                    controller.submit();
                });
            },

            error: function (message) {
                page.find('#error').html(message).show();
                page.find('#submit').removeAttr('disabled');
                page.find('#submit span').hide();
            },

            validate: function () {
                var error = '';
                page.find('#form [data-required]').each(function () {
                    var $this = wo$(this);
                    if ($this.val().trim() === '') {
                        $this.parents('.form-group').addClass('has-error');
                        error = clientData.requiredFields;
                    } else {
                        $this.parents('.form-group').removeClass('has-error');
                    }
                });

                return error;
            },

            submit: function () {
                var error = controller.validate();
                if (error !== '') {
                    controller.error(error);
                    return;
                }

                page.find('#error').hide();
                page.find('#submit').attr('disabled', '');
                page.find('#submit span').show();

                var data = {
                    firstName: page.find('#firstName').val().trim(),
                    lastName: page.find('#lastName').val().trim(),
                    email: page.find('#email').val().trim(),
                    enquiryType: page.find('#enquiryType').val().trim(),
                    description: page.find('#description').val().trim(),
                    referrer: document.referrer,
                    captchaResponse: page.find('#captcha-response').val()
                };

                wo$.ajax({
                    url: '/Ajax/Shared/General/SubmitContact',
                    data: data,
                    dataType: 'json',
                    type: 'POST',
                    success: function (result) {
                        if (result.success) {
                            page.find('#entry').hide();
                            page.find('#submitted').show();
                            WhistleOut.scrollTo(0);
                        } else {
                            controller.error(clientData.captchaFailed);
                            grecaptcha.reset();
                        }
                    },
                    error: function () {
                        controller.error(clientData.error);
                        grecaptcha.reset();
                    }
                });
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
